import { render } from "./AddressGrid.vue?vue&type=template&id=90442ba4&scoped=true"
import script from "./AddressGrid.vue?vue&type=script&lang=js"
export * from "./AddressGrid.vue?vue&type=script&lang=js"

import "./AddressGrid.vue?vue&type=style&index=0&id=90442ba4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-90442ba4"

export default script